var themeOptions = function (theme) { return ({
    components: {
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    alignItems: 'flex-start',
                    paddingTop: theme.spacing(1),
                },
                label: {
                    paddingTop: theme.spacing(0.125),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formControlLabelTheme.js.map